import moment from 'moment';

import appConfig from '../../config/config';
import { getFromSessionStorage, isNull } from '../../common/utils/app.utils';
import { MODULE_ID, SUMMARY_AUTHORIZATION_HEADER } from '../../home/common/constants/constants';
import { DATE_FORMATS } from './constants';
import { getOvToken } from 'tokenGeneration/lead.util';
import { MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN } from 'home/view/manage-feasibility/constants';

export const getFetchSlotApiConfig = (params) => {
  return {
    ENTERPRISE: {
      baseurl: appConfig.dedicatedSummaryApiUrl,
      endpoint: 'slots',
      params,
      authToken: getFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER) || getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN)
    },
    OV: {
      baseurl: appConfig.ovapiBaseUrl,
      endpoint: '/orders/slots',
      params,
      authToken: `Bearer ${getOvToken()}`
    }
  };
};

export const ampmParser = (time) => {
  const splittedTimeValue = time?.split(':');
  const hours = splittedTimeValue?.[0];
  const intHours = hours && parseInt(hours);
  const mins = splittedTimeValue?.[1];
  const intMins = mins && parseInt(mins);
  const sec = splittedTimeValue?.[2];

  const parsedTime = `${hours}:${mins}`;

  // 00:00 - 11:59 - AM
  // 12:00 - 23:59 - PM

  if (intHours >= 0 && intHours < 12) {
    return `${parsedTime} AM`;
  } else if (intHours > 12 && intHours < 24) {
    return `${parsedTime} PM`;
  } else if (intHours === 12) {
    return `${parsedTime} PM`;
  } else {
    throw new Error('Invalid time format');
  }
};

export const tableDataMapper = (records, handleLineItemClick) => {
  const rows = [];
  if (Object.keys(records).length > 0) {
    records?.sites?.forEach((record) => {
      const lsiId = record?.lsiId || '-';
      const installationAddress = record?.installationAddress || '-';
      const contactDetails = (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <span>{(record?.dcpFirstName || '-') + ' ' + (record?.dcpLastName || '-')}</span>
          <span>{record?.dcpPhoneNumber || '-'}</span>
        </div>
      );

      const pmDetails = (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <span>{(record?.pmFirstName || '-') + ' ' + (record?.pmLastName || '-')}</span>
          <span>{record?.pmPhoneNumber || '-'}</span>
          <span>{record?.pmEmail || '-'}</span>
        </div>
      );

      const customerNeedByDate = (record?.customerNeedByDate && moment(new Date(record?.customerNeedByDate)).format(DATE_FORMATS.DD_MMM_YYYY)) || '-';
      const siteReadinessStatus = !isNull(record?.siteReadinessStatus) ? (record?.siteReadinessStatus ? 'Yes' : 'No') : '-';
      const scheduleDate = (record?.appointmentDate && moment(new Date(record?.appointmentDate)).format(DATE_FORMATS.DD_MMM_YYYY)) || '-';
      const siteReadinessDate = (record?.siteReadinessDate && moment(new Date(record?.siteReadinessDate)).format(DATE_FORMATS.DD_MMM_YYYY)) || '-';
      const scheduleStartTime = (record?.appointmentStartTime && ampmParser(record?.appointmentStartTime)) || '-';
      const scheduleEndTime = (record?.appointmentEndTime && ampmParser(record?.appointmentEndTime)) || '-';
      const scheduleTime = `${scheduleStartTime} - ${scheduleEndTime}`;

      const siteReadiness =
        siteReadinessStatus === 'Yes' ? (
          siteReadinessStatus
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <span>{siteReadinessStatus}</span>
            <span>
              <i className="aeh-icon-outlined-calendar" /> {siteReadinessDate}
            </span>
          </div>
        );

      const appointmentDate = (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <span>
            <i className="aeh-icon-outlined-calendar" /> {scheduleDate}
          </span>
          <span>
            <i className="aeh-icon-outlined-clock-icon" /> {scheduleTime}
          </span>
        </div>
      );

      const actions = !record?.subOrderGenerated ? (
        <div
          style={{
            display: 'flex',
            color: '#CC000A',
            cursor: 'pointer'
          }}
          role="button"
          onClick={(e) => handleLineItemClick(e, record)}
        >
          <span>
            <i className="aeh-icon-outlined-pen-icon" /> Edit Details
          </span>
        </div>
      ) : (
        <span
          style={{
            color: '#16b27e'
          }}
        >
          Appointment confirmed by PM. Pls contact PM for any clarification
        </span>
      );

      const row = { lsiId, installationAddress, pmDetails, contactDetails, customerNeedByDate, siteReadiness, appointmentDate, actions };

      rows.push(row);
    });
  }
  return rows;
};
